<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen Home</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Manajemen Home</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabkategori" data-toggle="tab">Kategori</a>
                                            </li>
											<li class="nav-item">
												<a class="nav-link" href="#tabbanner" data-toggle="tab">Kategori Banner</a>                                                
											</li>     
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Tingkatan Tab -->
										<div id="tabkategori" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdl" @click="resetVar()">Tambah Kategori</a>
                                                    </div>
                                                    <!-- <datatable :columns="columns" :data="reftingkatan"></datatable> -->

													<div class="table-responsive">
                                                        <table id="tbl" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Nama Kategori</th>
                                                                    <th class="text-left">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstkategori" :key="ref.id">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_kat }}</td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-info-light' : ref.status == '1', 'bg-danger-light' : ref.status == '-1' }">{{ref.status_nm}}</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)" v-if="ref.ispakai=='0'">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
										<!-- /Class Records Tab -->
                                        
                                        
										<!-- Materi Tab -->
										<div id="tabbanner" class="tab-pane fade show">
                                             <div class="card card-table">
												<div class="card-body p-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-6">
                                                            <div class="form-group card-label">
                                                                <v-select
                                                                :options="lstkategoriforbanner"
                                                                :reduce="lstkategoriforbanner => lstkategoriforbanner.id" 
                                                                label="nama_kat"
                                                                v-model="id_banner_kat"
                                                                placeholder="Silahkan pilih Kategori"
                                                                required
                                                                />
                                                                
                                                            </div>
                                                        </div>
                                                        <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAllBanner()"> Lihat Banner </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

											<div class="card card-table mb-0">
												<div class="card-body">
                             
                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdlBanner" @click="resetVarBanner()">Tambah Banner</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblBanner" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Kode Banner</th>
                                                                    <th class="text-left">Link Banner</th>
                                                                    <th class="text-left">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstbanner" :key="ref.id_banner">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.kode_banner }}</td>
                                                                    <td>{{ ref.link_banner }}</td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-info-light' : ref.status == '1', 'bg-danger-light' : ref.status == '-1' }">{{ref.status_nm}}</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEditBanner(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDeleteBanner(ref)" >
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Banner Tab -->
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="addMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Kategori Paket</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Nama Kategori <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="kategori.nama_kat">
                            </div>
                            <div class="form-group card-label">
                                <label>Status</label>
                                <v-select
                                :options="lststskategori"
                                :reduce="lststskategori => lststskategori.id" 
                                label="text"
                                v-model="kategori.status"
                                />	
                            </div>
                            <div class="form-group">
                                <label>Link Icon <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="kategori.icon">
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="save">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Kategori</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus kategori paket <b>{{ kategori.nama_kat }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


        
        <div id="addMdlBanner" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Banner Kategori</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Kategori</label>
                                <v-select
                                :options="lstkategoriforbanner"
                                :reduce="lstkategoriforbanner => lstkategoriforbanner.id" 
                                label="nama_kat"
                                v-model="banner.id_kat"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Kode Banner <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="banner.kode_banner">
                            </div>
                            <div class="form-group">
                                <label>Link Banner <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="banner.link_banner">
                            </div>
                            <div class="form-group card-label">
                                <label>Status</label>
                                <v-select
                                :options="lststskategori"
                                :reduce="lststskategori => lststskategori.id" 
                                label="text"
                                v-model="banner.status"
                                />	
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="saveBanner">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="delMdlBanner" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Banner</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus kategori banner ini</label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapusBanner">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'admin-ref-home',
    // vuetify: new Vuetify(),
    data() {
        return {
            lstkategori: [],
            kategori:{
                id: '',
                nama_kat: '',
                status: '',
                icon: '',
                status_nm: '',
                ispakai: ''
            },
            lststskategori: [
                {id: '1', text: 'AKTIF'},
                {id: '-1', text: 'TIDAK AKTIF'}
            ],      
            lstkategoriforbanner: [],      
            lstbanner: [],
            banner:{
                id_banner: '',
                id_kat: '',
                kode_banner:'',
                link_banner: '',
                status_nm: '',
                status: ''
            },
            id_banner_kat :''
            // lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     id: '',
            //     nama_materi: '',
            // },
            // lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
        }
    },
    created: function () {
        // this.refreshAll();
        
        this.getAll();
        // this.getAllMateri();
        // this.getAllSub();
        // this.initDt("tblMateri");
        // this.initDt("tblSub");

    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
                });
               }, 300)
               
                
        },
      
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        refreshAll(){
            this.getAll();
            // this.getAllMateri();
            // this.getAllSub();
            
            // this.reloadTbl("tbl");
            // this.reloadTbl("tblMateri");
            // this.reloadTbl("tblSub");
        },

        // Get Kategori
        getAll: function () {
            axios.get('api/kategoripaket')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tbl");
                    this.lstkategori = res.data.data;
                    this.lstkategoriforbanner = res.data.dataforbanner;
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New product
        save: function () {
            axios.post('api/kategoripaket', {
                    id: this.kategori.id,
                    nama_kat: this.kategori.nama_kat,
                    status: this.kategori.status,
                    icon: this.kategori.icon
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        resetVar: function(ref){
            if(ref){
                this.kategori.id = ref.id;
                this.kategori.nama_kat = ref.nama_kat;
                this.kategori.status = ref.status;
                this.kategori.icon = ref.icon;
            } else {
                this.kategori.id = '';
                this.kategori.nama_kat = '';
                this.kategori.status = '';
                this.kategori.icon = '';
            }
        },

        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Product
        hapus: function () {
            axios.post('api/kategoripaketdel', {
                    id: this.kategori.id,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#delMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        
        // Get Banner
        getAllBanner: function () {
            axios.get('api/manajemenbanner/'+this.id_banner_kat)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblBanner");
                    this.lstbanner = res.data.data;
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New product
        saveBanner: function () {
            axios.post('api/manajemenbanner', {
                    id_banner: this.banner.id_banner,
                    id_kat: this.banner.id_kat,
                    kode_banner: this.banner.kode_banner,
                    status: this.banner.status,
                    link_banner: this.banner.link_banner
                })
                .then(res => {
                    // handle success
                    this.getAllBanner();
                    this.resetVarBanner();
                    $("#addMdlBanner").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        resetVarBanner: function(ref){
            if(ref){
                this.banner.id_banner = ref.id_banner;
                this.banner.id_kat = ref.id_kat;
                this.banner.kode_banner = ref.kode_banner;
                this.banner.status = ref.status;
                this.banner.link_banner = ref.link_banner;
            } else {

                this.banner.id_banner = '';
                this.banner.id_kat = this.id_banner_kat;
                this.banner.kode_banner = '';
                this.banner.status = '';
                this.banner.link_banner = '';
            }
        },

        // Get Edit and Show data to Modal
        getEditBanner: function (ref) {
            this.resetVarBanner(ref);
            $("#addMdlBanner").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDeleteBanner: function (ref) {
            this.resetVarBanner(ref);
            $("#delMdlBanner").modal('show');
        },
 
        // Delete Product
        hapusBanner: function () {
            axios.post('api/manajemenbannerdel', {
                    id_banner: this.banner.id_banner,
                })
                .then(res => {
                    // handle success
                    this.getAllBanner();
                    this.resetVarBanner();
                    $("#delMdlBanner").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/RefHome/index.vue